// ============================================
// Prenta — Formatting Utilities
// ============================================

/**
 * Format Unix timestamp to relative Icelandic time string.
 */
export function formatTimeAgo(timestamp) {
  if (!timestamp) return '';
  const now = Date.now();
  const time = typeof timestamp === 'number'
    ? (timestamp > 1e12 ? timestamp : timestamp * 1000)
    : new Date(timestamp).getTime();
  const diff = Math.floor((now - time) / 1000);

  if (diff < 60) return 'Rétt í þessu';
  if (diff < 3600) return `${Math.floor(diff / 60)} mín síðan`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} klst síðan`;
  if (diff < 604800) return `${Math.floor(diff / 86400)} dögum síðan`;
  return new Date(time).toLocaleDateString('is-IS');
}

/**
 * Format ISK price.
 */
export function formatPrice(amount) {
  if (amount == null) return 'Samkomulag';
  return `${Number(amount).toLocaleString('is-IS')} kr.`;
}

/**
 * Format turnaround days.
 */
export function formatDays(days) {
  if (!days) return 'Eftir samkomulagi';
  if (days === 1) return '1 dagur';
  return `${days} dagar`;
}
